// AI Generated Component
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'page-details-seo-table',
    standalone: false,
    template: `
        <div class="max-height d-flex flex-column">
            <page-details-sections-tabs [tab]="tab"
                                        [options]="tabOptions"
                                        (onTabChange)="onTabChange($event.tab)" class="block border-bottom border-right px-3">
            </page-details-sections-tabs>
            <div class="flex-grow-1">
                <mon-spinner [progress]="progress">
                    <table class="table table-hover table-fixed seo-issues">
                        <thead>
                        <tr>
                            <th class="col-sm-8 col-md-6 col-lg-4"></th>
                            <th class="col-sm-26 col-md-32 col-lg-37" translate>Issue</th>
                            <th class="col-sm-14 col-md-10 col-lg-7 text-right">
                        <span class="inner-r-medium" translate>
                            SEO impact
                        </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr [ngClass]="{'selectedSEO': seo.id === selectedSeoIssue.id }"
                            (click)="onChangePageSeoIssue.emit({pageSeoIssue: seo})"
                            role="button"
                            *ngFor="let seo of getSeoIssues(); trackBy: trackBySeoId">
                            <td class="text-v-middle" [attr.aria-label]="'Icon' | translate">
                                <mon-table-policy-type
                                    class="inline-block inner-l-medium inner-t-mini inner-b-mini"
                                    [color]="classificationColors[seo.ignored_on_page ? 'ignored' : seo.classification]"
                                    [passed]="!seo.ignored_on_page && seo.fixed"
                                    [target]="target"
                                >
                                </mon-table-policy-type>
                            </td>
                            <td class="text-v-middle">
                        <span [attr.data-test]="seo.translation_name | e2eAttributeEncoding" [ngClass]="setTitleClass(seo)">
                            {{ seo.translation_name | translateSeoIssue }}
                        </span>
                            </td>
                            <td class="text-v-middle text-right">
                        <span class="inner-r-medium">
                            <span *ngIf="seo.classification !== 4 && (!seo.ignored_on_page && !seo.fixed)">
                                <span class="fas fa-circle" [ngClass]="{ 'text-danger': seo.classification === 1, 'text-warning': seo.classification === 2, 'text-info': seo.classification === 3 }"></span>
                                <span class="fas fa-circle" [ngClass]="{ 'text-danger': seo.classification === 1, 'text-warning': seo.classification === 2, 'text-grey': seo.classification === 3 }"></span>
                                <span class="fas fa-circle" [ngClass]="{ 'text-danger': seo.classification === 1, 'text-grey': seo.classification !== 1 }"></span>
                            </span>
                            <span *ngIf="!seo.ignored_on_page && seo.fixed"
                                  class="text-success"
                                  translate>
                                No issues found
                            </span>
                            <span *ngIf="seo.ignored_on_page"
                                  class="text-grey"
                                  translate>
                                Ignored
                            </span>
                        </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </mon-spinner>
            </div>
        </div>
    `,
})
export class PageDetailsSeoTableComponent implements OnInit {
    @Input() pageSeoIssues: any[] = [];
    @Input() selectedSeoIssue: any = {};
    @Input() progress: any;
    @Output() onChangePageSeoIssue = new EventEmitter<{ pageSeoIssue: any }>();

    target: string = '';
    classificationColors: any;
    tabOptions: any[] = [];
    tab: any;

    constructor (
        private translateService: TranslateService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.target = 'seo';
        this.classificationColors = {
            1: 'danger',
            2: 'warning',
            3: 'link',
            4: 'primary',
            ignored: 'grey',
        };
        this.setupTabs();
    }

    setupTabs (): void {
        this.tabOptions = [
            {
                name: this.translateService.getString('All'),
                value: null,
            },
            {
                name: this.translateService.getString('High'),
                value: 1,
            },
            {
                name: this.translateService.getString('Medium'),
                value: 2,
            },
            {
                name: this.translateService.getString('Low'),
                value: 3,
            },
            {
                name: this.translateService.getString('Technical'),
                value: 4,
            },
        ];

        this.tab = this.tabOptions[0].value;
    }

    setTitleClass (seo: any): any {
        return {
            'text-link': !seo.ignored_on_page && !seo.fixed,
            'text-grey': seo.ignored_on_page || seo.fixed,
        };
    }

    onTabChange (tab: any): void {
        this.tab = tab;

        const seoIssues = this.getSeoIssues();
        let seoIssue = seoIssues[0];
        if (this.selectedSeoIssue && typeof this.selectedSeoIssue === 'object') {
            const foundIssue = seoIssues.find((seo: any) => seo.id === this.selectedSeoIssue.id);
            seoIssue = foundIssue || seoIssues[0];
        }
        this.onChangePageSeoIssue.emit({ pageSeoIssue: seoIssue });
    }

    getSeoIssues (): any[] {
        if (!this.pageSeoIssues) {
            return [];
        }
        return this.pageSeoIssues.filter((data: any) => {
            return data.classification === this.tab || this.tab === null;
        });
    }

    trackBySeoId (index: number, seo: any): any {
        return index;
    }
}
